<template>
  <div class="content blacklist">
    <div class="header">
      <div class="row">
        <div class="box">
          <span class="title">手机号</span>
          <el-input
            size="small"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="mobile"
            clearable
            class="input_box">
          </el-input>
          <el-button size="small" type="primary" @click="getData(1)">搜索</el-button>
        </div>
      </div>
    </div>
    <template>
      <el-table border :data="tableData" style="width: 100%" size="small">
        <el-table-column prop="real_name" label="姓名" width="140"></el-table-column>
        <el-table-column prop="mobile" label="手机号" ></el-table-column>
        <el-table-column prop="level_name" label="等级" ></el-table-column>
        <el-table-column prop="spread_num" label="分销人数"></el-table-column>
        <el-table-column prop="commission" label="可用佣金"></el-table-column>
        <el-table-column prop="frozen_commission" label="未结算佣金"></el-table-column>
        <el-table-column prop="total_commission" label="累计佣金"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-popover
              placement="left"
              width="150"
              trigger="click"
              :ref="'popover-' + scope.row.uid">
              <el-button size="medium" class="propver_button" @click="detailItem(scope.row.uid,1)">分销佣金记录</el-button>
              <el-button size="medium" class="propver_button" @click="detailItem(scope.row.uid,2)">分销充值记录</el-button>
              <el-button size="medium" class="propver_button" @click="detailItem(scope.row.uid,3)">分销订单记录</el-button>
              <el-button size="medium" class="propver_button" @click="detailItem(scope.row.uid,4)">分销用户记录</el-button>
              <el-button slot="reference" type="text">查看详情</el-button>
            </el-popover>
            <el-button type="text" style="margin-left:10px" @click="changeLevel(scope.row.uid)">修改等级</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="page-next">
      <el-pagination
        background
        layout="prev, pager, next, total"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showDetail" :title="detailTitle" width="700px" @close="closeDetail()">
      <!-- 分销佣金记录 -->
      <el-table :data="detailData" v-if="detailType == 1">
        <el-table-column label="变动原因" prop="show_style"></el-table-column>
        <el-table-column label="变动金额">
          <template slot-scope="scope">
            {{scope.row.show_type + scope.row.amount}}
          </template>
        </el-table-column>
        <el-table-column label="冻结金额" prop="frozen_amount"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column label="状态" prop="show_status"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
      </el-table>
      <!-- 分销充值记录 -->
      <el-table :data="detailData" v-if="detailType == 2">
        <el-table-column label="变动金额">
          <template slot-scope="scope">
            {{scope.row.show_type + scope.row.amount}}
          </template>
        </el-table-column>
        <el-table-column label="冻结金额" prop="frozen_amount"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column label="状态" prop="show_status"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
      </el-table>
      <!-- 分销订单记录 -->
      <el-table :data="detailData" v-if="detailType == 3">
        <el-table-column label="变动金额">
          <template slot-scope="scope">
            {{scope.row.show_type + scope.row.amount}}
          </template>
        </el-table-column>
        <el-table-column label="冻结金额" prop="frozen_amount"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column label="状态" prop="show_status"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
      </el-table>
      <!-- 分销用户记录 -->
      <el-table :data="detailData" v-if="detailType == 4">
        <el-table-column label="邀请用户id" prop="uid"></el-table-column>
        <el-table-column label="状态" prop="show_status"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
      </el-table>
      
      <div style="margin-top:15px">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :current-page="detailPage"
          :total="detailTotal"
          :page-size="10"
          @current-change="handleDetailChange">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showLevel" title="修改等级" @close="closeLevel" width="360px">
      <el-form :model="levelForm" label-width="70px" size="small">
        <el-form-item label="等级">
          <el-select v-model="levelForm.id">
            <el-option v-for="item in levelList" :key="item.id" :value="item.id" :label="item.level_name"></el-option>
          </el-select>
        </el-form-item>
        <div style="margin-top:25px;text-align:center">
          <el-button size="small" type="primary" @click="saveLevel()">保存</el-button>
          <el-button size="small" @click="closeLevel()">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getSpreadList,getSpreadMoney,getSpreadRecharge,getSpreadOrder,getSpreadUser,getlevel,changeSpreadLevel } from "@/api/user";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      screen: {},
      tableData: [],
      page: 1,
      total: 0,
      showDetail: false, // 查看详情
      detailType: 1, // 查看详情类型 1.佣金 2.充值 3.订单 4.用户
      detailUid: "", // 查看详情的uid
      detailTitle: "", // 详情标题
      detailData: [], // 详情内容
      detailPage: 1, // 详情分页
      detailTotal: 0, // 详情总数
      showLevel: false, // 修改等级弹窗
      levelList: [], // 等级列表
      levelForm: {
        uid: "",
        id:""
      }, // 修改等级表单
      mobile: "", // 手机号检索
    };
  },
  mounted() {
    this.getData();
    this.init();
  },
  methods: {
    init(){
      getlevel({app_id: this.app_id,status: 0}).then(res => {
        if(res.code == 200){
          this.levelList = res.data;
        }
      })
    },
    getData(i){
      this.page = i || this.page;
      var data = {
        app_id: this.app_id,
        page: this.page,
      }
      if(this.mobile != ""){
        data.mobile = this.mobile
      }
      getSpreadList(data).then(res => {
        if(res.code == 200){
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    },
    handleDetailChange(val){
      this.detailPage = val;
      this.getDetailData();
    },
    detailItem(id,type){
      this.detailUid = id;
      this.detailType = type;
      this.detailTitle = type == 1? "分销佣金记录":type == 2? "分销充值记录":type == 3? "分销订单记录":"分销用户记录"
      this.showDetail = true;
      this.getDetailData();
      this.pClose(id);
    },
    pClose(id) {
      this.$refs[`popover-` + id].doClose()
    },
    closeDetail(){
      this.showDetail = false;
      this.detailData = [];
      this.detailPage = 1;
      this.detailTotal = 0;
    },
    getDetailData(){
      var data = {
        app_id: this.app_id,
        page: this.detailPage,
        uid: this.detailUid
      }
      if(this.detailType == 1){ // 分销佣金记录
        getSpreadMoney(data).then(res => {
          if(res.code == 200) {
            this.detailData = res.data.data;
            this.detailTotal = res.data.total;
            this.detailData.forEach(item => {
              item.show_style = item.style == 1? "订单":item.style == 2? "充值":item.style == 3? "提现":item.style == 4? "邀请新人":"其他"
              item.show_type = item.type == 1? "+":item.type == 2? "-":""
              item.show_value = item.show_type + item.amount;
              item.show_status = item.status == 0? "未结算":"已结算"
            })
          }else{
            this.$message(res.msg);
          }
        })
      }else if(this.detailType == 2){ // 分销充值记录
        getSpreadRecharge(data).then(res => {
          if(res.code == 200) {
            this.detailData = res.data.data;
            this.detailTotal = res.data.total;
            this.detailData.forEach(item => {
              item.show_type = item.type == 1? "+":item.type == 2? "-":""
              item.show_status = item.status == 0? "未结算":"已结算"
            })
          }else{
            this.$message(res.msg);
          }
        })
      }else if(this.detailType == 3){ // 分销订单记录
        getSpreadOrder(data).then(res => {
          if(res.code == 200) {
            this.detailData = res.data.data;
            this.detailTotal = res.data.total;
            this.detailData.forEach(item => {
              item.show_type = item.type == 1? "+":item.type == 2? "-":""
              item.show_status = item.status == 0? "未结算":"已结算"
            })
          }else{
            this.$message(res.msg);
          }
        })
      }else if(this.detailType == 4){ // 分销用户记录
        getSpreadUser(data).then(res => {
          if(res.code == 200) {        
            this.detailData = [];
            this.detailData = res.data.data;
            this.detailTotal = res.data.total;
            this.detailData.forEach(item => {
              item.show_status = item.status == 0? "未成功":"邀请成功";
            })
          }else{
            this.$message(res.msg);
          }
        })
      }
    },
    changeLevel(id){
      this.levelForm.uid = id;
      this.showLevel = true;
    },
    closeLevel(){
      this.showLevel = false;
      this.levelForm = {
        id: "",
        uid: "",
      }
    },
    saveLevel(){
      if(this.levelForm.id == ""){
        this.$message('请选择分销商等级')
      }else{
        var data = Object.assign({},this.levelForm)
        data.app_id = this.app_id;
        changeSpreadLevel(data).then( res => {
          if(res.code == 200){
            this.$message.success("保存成功");
            this.getData();
            this.closeLevel();
          }else{
            this.$message(res.msg)
          }
        })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.blacklist {
  padding: 10px 25px;
  .header {
    padding: 10px 10px;
    
    .row{
      display: flex;
      padding: 6px 0;
    }
    .box{
      width: 50%;
      line-height: 40px;
      .title{
        padding-right: 20px;
      }
      .input_box{
        width: 240px;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
  .img {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    img {
      width: 80%;
    }
  }
  .cao-zuo {
    width: 60%;
    display: flex;
    padding: 0 20px;
    margin: 0 auto;
    justify-content: space-between;
  }
  .page-next {
    margin-top: 10px;
  }
}
.propver_button{
  width: 124px;
  text-align: center;
  margin:5px 0;
}
</style>

<style lang="scss">
.blacklist {
  .has-gutter > tr > th {
    color: #333;
    background-color: #f8f8f8;
  }
  .cell {
    text-align: center;
  }
}
</style>
